import { TIMEZONE } from "../../../config/helper";
import { PUBLIC_HOLIDAYS } from "../HomeSlice";
import momentTz from "moment-timezone";

export const getPublicHolidaysWithEves = () => {
  return PUBLIC_HOLIDAYS.flatMap((date) => {
    const holiday = momentTz.tz(date, "DD/MM/YYYY", TIMEZONE);
    const eve = holiday.clone().subtract(1, "day");
    return [holiday, eve];
  });
};
